const co = {
  sdyx: {
    agentId: '3000',
    name: '普通',
    openType: 1,
  },
  'sdyx-vip': {
    agentId: '3001',
    name: 'VIP',
    openType: 1,
  },
  'sdyx-yc': {
    agentId: '3002',
    name: '苏打优创',
    openType: 1,
  },
  'sdyx-mzvip': {
    agentId: '3003',
    name: '苏打爱生活卖座vip',
    openType: 5,

  },
  'sdyx-mzapp': {
    agentId: '3005',
    name: '苏打爱生活卖座电影app',
    openType: 0,
  },
  'sdyx-jsyc': {
    agentId: '3006',
    name: '苏打爱生活江苏邮储',
    openType: 7,
  },
  'sdyx-mzmovie': {
    agentId: '3007',
    name: '苏打爱生活卖座电影v5渠道',
    openType: 5,
  },
  'sdyx-xhzs': {
    agentId: '3008',
    name: '星河智善',
    openType: 1,
  },
  'sdyx-qyg': {
    agentId: '3011',
    name: '企业购',
    openType: 1,
  },
  'mp-sdtj': {
    agentId: '3012',
    name: '苏打体检小程序',
    openType: 1,
  }
}

export default co
